import React from 'react';

export default function BottomFadeMask({ height = 180, fadeStart = '5rem' }) {
    const maskImage = `linear-gradient(transparent, #000 ${fadeStart})`;
    return (
        <div
            className="absolute bottom-0 left-4 right-4 pointer-events-none"
            style={{ height: `${height}px`, WebkitMaskImage: maskImage, maskImage }}
        >
            <div className="absolute -left-4 -right-4 bottom-0 top-0 overflow-hidden">
                <div className="absolute w-full h-full bg-app-bg" />
            </div>
        </div>
    );
}
